<template>
  <transition @appear="enter" @enter="enter" @leave="leave" :css="false">
    <div class="PricesHome-header">
      <div class="PricesHome-header-left">
        <router-link to="/">
          <img :src="images.logo" />
        </router-link>
      </div>
    </div>
  </transition>
</template>

<script>
import { TweenMax } from "gsap";

export default {
  props: {
    length: Number,
    active: Number,
  },
  data: () => ({
    images: {
      logo: require("@/assets/img/logo.svg"),
    },
  }),
  methods: {
    enter(el, done) {
      const delay = 0.3;
      TweenMax.fromTo(
        el,
        0.5,
        {
          autoAlpha: 0,
          y: 30,
          onComplete: done,
        },
        {
          autoAlpha: 1,
          y: 0,
          delay: delay,
          ease: "power2.easeInOut",
        },
      );
    },
    leave(el, done) {
      TweenMax.to(el, 0.2, {
        autoAlpha: 0,
        onComplete: done,
        ease: "power2.easeInOut",
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
@import './PricesHeader.styl';
</style>
